import { formatTimestamp } from '../lib/format';

interface TicketHeadProps {
  /** What the object is, e.g. `Record / product`. Rendered uppercase. */
  label: string;
  /** Real ISO timestamp for this object. Omitted when there is none — never faked. */
  timestamp?: string | null;
}

/**
 * Traveler-card header strip. Every ticket-like container on screen carries one:
 * the entity type on the left, the object's own timestamp on the right.
 *
 * Presentational only — mono is reserved for structural microlabels and real
 * system data, per the brand system.
 */
export function TicketHead({ label, timestamp = null }: TicketHeadProps) {
  return (
    <div className="ticket-head">
      <span className="ticket-head__label">{label}</span>
      {timestamp ? <span className="ticket-head__stamp">{formatTimestamp(timestamp)}</span> : null}
    </div>
  );
}
